import axios from "axios";
import commonServices from "@/shared/commonServices";
import uuid4 from "uuid4";

import { mapGetters } from "vuex";
export default {
  mixins: [commonServices],
  data: function () {
    return {
      apiAuthEncoded:"",
      subKey: ""
    };
  },
  computed: {
    ...mapGetters({
      posData: "posData",
    }),
  },
  async mounted(){
    // await this.getKeys();
  },
  methods: {
    async getKeys(){
      let dataURL = this.apiURL + 'Shared/getMtnKeys';
      let response = await axios.post(dataURL, {});
      if (response.data.status === 'success') {
        this.subKey = response.data.results.subKey;
        this.apiAuthEncoded = response.data.results.apiAuthEncoded;
      }
    },
    async createToken() {
      var myHeaders = new Headers();
      myHeaders.append(
        "Ocp-Apim-Subscription-Key",
        this.subKey
      );
      myHeaders.append("Cache-Control", "no-cache");
      myHeaders.append(
        "Authorization",
        "Basic " + this.apiAuthEncoded
      );

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };

      const result = await fetch(
        "https://sandbox.momodeveloper.mtn.com/collection/token/",
        requestOptions
      )
        .then((response) => response.json())
        .catch(async (error) => {
          await this.showAlert("Failed Please Retry");
          console.log("error", error);
        });
      if (result.access_token) {
        return access_token;
      } else {
        await this.showAlert("Failed Please Retry");
      }
    },
    async createPayment(amount, number) {
      let X_Reference_Id =  uuid4();
      const body = {
        amount: `${amount}`,
        number: `${number}`,
        externalId: uuid4(),
        X_Reference_Id
      };
      let dataURL = this.apiURL + 'Mtn/createPayment';
      let response = await axios.post(dataURL, body);
      if (response.data.message === 'success') {
        this.showSuccess("Payment Sent");
        return X_Reference_Id;
      }
    },
    async checkStatus(refId) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.createToken()}`);
      myHeaders.append(
        "X-Reference-Id",
        refId
      );
      myHeaders.append(
        "Ocp-Apim-Subscription-Key",
        this.subKey
      );
      myHeaders.append("Cache-Control", "application/json");
      myHeaders.append("Content-Type", "no-cache");
      myHeaders.append("X-Target-Environment", "sandbox");
      const res = await fetch(
        "https://sandbox.momodeveloper.mtn.com/collection/v1_0/requesttopay/" +
          refId,
        {
          method: "GET",
          headers: myHeaders,
        }
      )
        .then((response) => response.json())
        .catch(async (err) => {
          await this.showAlert("Failed Please Retry");
          console.error(err);
        });

      if (res.status == "SUCCESSFUL") {
        return true;
      } else {
        return false;
      }
    },
  },
};
